document.addEventListener('DOMContentLoaded', () => {
    initRegisterChecks();
});

function initRegisterChecks () {
    jQuery(document).on('submit', 'form#middleware_create_customer', function (e) {
        if (e) e.preventDefault();
        if(jQuery('#customer_email_HP').val() != '') {
            return;
        }
        checkform();
    });
    jQuery(document).on('submit', 'form#create_customer', function (e) {
        if(jQuery('#customer_email_HP').val() != '') {
            e.preventDefault();
            return;
        }
    });
}


function checkform () {
    jQuery('#middlewareRegisterSubmit').attr('value','Checking...').prop('disabled', true);
    jQuery('#middleware_create_customer .errors').remove();

    var validate = window.btoa(jQuery('#middlewareEmail').val());
    var Authorization = "Basic Z29lZGh1aXNAcHdrcy5jbzpnMDNkaHUxNSUx";
    var environment = "live";
    var password = jQuery('#middlewareCreatePassword').val();
    var passwordLength = 5;
    var password_length_error_text = jQuery('#middlewareCreatePassword').attr('password-length-error-text')
    //var url = "https://bordeaux.pwks.co/api/DynamicsNav/Goedhuis/ValidateAccount";
    var url = "/tools/signin/ValidateAccount";

    if(password.length < passwordLength) {
        var errorMessage = `<div class="errors">
        <ul>
            <li>
                ${password_length_error_text}
            </li>
        </ul>
        </div>`;
        jQuery('#middlewareCreatePassword').after(errorMessage);
        setTimeout(function() {
            jQuery('#middlewareRegisterSubmit').attr('value','Create').prop('disabled', false);
        }, 300);
    } else {
        jQuery.ajax({
            url: url,
            type: "GET",
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', Authorization);
                xhr.setRequestHeader('environment', environment);
                xhr.setRequestHeader('validate', validate);
            },
            success: function(result) {
                formResult(result)
            }
        });
    }
}

function formResult (result) {

    if (!result) {
        const errorMessage = `<div class="errors">
                <ul>
                    <li>
                        An error occurred with you submission. Please try again.
                    </li>
                </ul>
            </div>`;
        jQuery('#middleware_create_customer').prepend(errorMessage);
        return
    }

    if ((result['email-found'])) {
        var errorMessage = '<div class="errors"><ul><li><a href="/pages/login#direct">'+jQuery('#middleware_create_customer').attr('data-emailexists')+'</li></ul></div>';
        jQuery('#middleware_create_customer').prepend(errorMessage);
        jQuery('#middlewareRegisterSubmit').attr('value','Create').prop('disabled', false);
    }

    if (!result['email-found']) {
         // pass on to Shopify form as normal:
        jQuery('#FirstName').val(jQuery('#middlewareFirstName').val());
        jQuery('#LastName').val(jQuery('#middlewareLastName').val());
        jQuery('#Email').val(jQuery('#middlewareEmail').val());
        jQuery('#CreatePassword').val(jQuery('#middlewareCreatePassword').val());

        if (jQuery('#middlewareMarketing').is(':checked')) {
            jQuery('#marketing').prop('checked', true);
        } else {
            jQuery('#marketing').prop('checked', false);
        }
        jQuery('#standardRegisterSubmit').click();
    }
}


